var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../strings/i18n';
import { Footer, FooterWrapper } from './subcomponents';
import { ChangePaymentDueDateScreen } from '../../typings';
var ChangePaymentDueDateFooter = function (_a) {
    var _b;
    var currentScreen = _a.currentScreen, handleClose = _a.handleClose, handleClick = _a.handleClick, selectedDay = _a.selectedDay;
    var DATA_PRIMARY_TYPE = 'change due date';
    var DATA_SECONDARY_TYPE = 'back to account services';
    var DATA_CLOSE_TYPE = 'close';
    var DATA_OBJECT = 'button';
    var DATA_REASON = selectedDay ? 'selected' : 'current';
    var closeButtonPrimary = {
        primaryText: translate('button.close'),
        handlePrimaryButton: handleClose,
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryType: DATA_CLOSE_TYPE
    };
    var initialScreenButtons = {
        primaryText: translate('button.changeDueDate'),
        handlePrimaryButton: handleClick,
        dataPrimaryObject: DATA_OBJECT,
        dataPrimaryReason: DATA_REASON,
        dataPrimaryType: DATA_PRIMARY_TYPE,
        secondaryText: translate('button.backToAccountServices'),
        handleSecondaryButton: handleClose,
        secondaryButtonType: 'ghost',
        dataSecondaryObject: DATA_OBJECT,
        dataSecondaryReason: DATA_REASON,
        dataSecondaryType: DATA_SECONDARY_TYPE
    };
    var changePaymentDueDateFooter = (_b = {},
        _b[ChangePaymentDueDateScreen.EXECUTION_ERROR_SCREEN] = closeButtonPrimary,
        _b[ChangePaymentDueDateScreen.INITIAL_SCREEN] = initialScreenButtons,
        _b[ChangePaymentDueDateScreen.SELECT_DAY_ERROR_SCREEN] = initialScreenButtons,
        _b[ChangePaymentDueDateScreen.SUCCESSFUL_SCREEN] = closeButtonPrimary,
        _b);
    return (_jsx(FooterWrapper, __assign({ "data-testid": "change-payment-due-date-footer" }, { children: _jsx(Footer, __assign({}, changePaymentDueDateFooter[currentScreen])) })));
};
export default ChangePaymentDueDateFooter;
